import { ProvidedServiceType } from "./doctor.definition";
import { FacilityType } from "./facility.definition";
import { SpecialtyCode } from "./specialty.definition";
import { CivilityType, RoleType } from "./user.definition";

export type SearchRequest = {
  paginationSettings: paginationSettings;
  sortBy: SortBy;
  query: Query;
};

export enum CareTypes {
  ICU,
  VACCINATION,
  SURGERY,
  EMERGENCY,
}

export type Query = {
  keyword: string;
  specialtyCodes?: SpecialtyCode[];
  careTypeCodes?: CareTypes[];
  facilityType?: FacilityType;
  providedServiceCodes?: ProvidedServiceType[];
  civility?: CivilityType;
  role?: RoleType;
  maxAge?: number;
  minAge?: number;
};

export type SortBy = {
  property: string;
  order: OrderBy;
};

export type paginationSettings = {
  limit: number;
  offset?: number;
};
export type OrderBy = (typeof Order)[keyof typeof Order];

export const Order = {
  ASC: "ASC",
  DESC: "DESC",
};

export type InputsSearch = {
  civility?: CivilityType;
  isOnlineService?: boolean;
  isHomeService?: boolean;
  isClinicService?: boolean;
  order?: OrderBy;
  keyword?: string;
};

export type DashboardFilterBy =
  (typeof DashboardFilterEnum)[keyof typeof DashboardFilterEnum];

export const DashboardFilterEnum = {
  WEEK: "WEEK",
  MONTH: "MONTH",
  YEAR: "YEAR",
  ALL_TIME: "ALL_TIME",
};

export type PaginationSettingsResponse = {
  totalCount: number;
  pageSize: number;
  offset: {
    current: number;
    last: boolean;
  };
};

export const defaultSearchRequest: SearchRequest = {
  paginationSettings: {
    limit: 10,
    offset: 0,
  },
  sortBy: {
    property: "",
    order: Order.ASC,
  },
  query: {
    keyword: "",
  },
};

export type KeywordSearchRequest = {
  keyword: string;
};

export type SearchResponse<T> = {
  data: T[];
  paginationSettings: PaginationSettingsResponse;
};
